"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var debug_1 = __importDefault(require("../debug"));
/** @private */
exports.siteNameError = 'The site name must be a non-empty string';
/** @private */
exports.languageError = 'The language must be a non-empty string';
/*
 * GraphQL query that returns the ID of the root item of the specified site and language
 */
var appRootQuery = /* GraphQL */ "\n  query AppRootQuery($jssAppTemplateId: String!, $siteName: String!, $language: String!) {\n    layout(site: $siteName, routePath: \"/\", language: $language) {\n      homePage: item {\n        rootItem: ancestors(includeTemplateIDs: [$jssAppTemplateId]) {\n          id\n        }\n      }\n    }\n  }\n";
/**
 * Gets the ID of the JSS App root item for the specified site and language.
 * @param {GraphQLClient} client that fetches data from a GraphQL endpoint.
 * @param {string} siteName the name of the Sitecore site.
 * @param {string} language the item language version.
 * @param {string} jssAppTemplateId optional template ID of the app root item. If not
 * specified, the ID of the "/sitecore/templates/Foundation/JavaScript Services/App"
 * item is used.
 * @returns the root item ID of the JSS App in Sitecore. Returns null if the app root item is not found.
 * @throws {RangeError} if a valid site name value is not provided.
 * @throws {RangeError} if a valid language value is not provided.
 * This function intentionally avoids throwing an error if a root item is not found,
 * leaving that decision up to implementations.
 */
function getAppRootId(client, siteName, language, jssAppTemplateId) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var fetchResponse;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!siteName) {
                        throw new RangeError(exports.siteNameError);
                    }
                    if (!language) {
                        throw new RangeError(exports.languageError);
                    }
                    debug_1.default.dictionary('fetching site root for %s %s', language, siteName);
                    return [4 /*yield*/, client.request(appRootQuery, {
                            jssAppTemplateId: jssAppTemplateId || constants_1.SitecoreTemplateId.JssApp,
                            siteName: siteName,
                            language: language,
                        })];
                case 1:
                    fetchResponse = _e.sent();
                    if (!((_d = (_c = (_b = (_a = fetchResponse) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.homePage) === null || _c === void 0 ? void 0 : _c.rootItem) === null || _d === void 0 ? void 0 : _d.length)) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, fetchResponse.layout.homePage.rootItem[0].id];
            }
        });
    });
}
exports.getAppRootId = getAppRootId;
